import { render, staticRenderFns } from "./ModalEditShoppingItem.vue?vue&type=template&id=1e6e95f0"
import script from "./ModalEditShoppingItem.vue?vue&type=script&lang=js"
export * from "./ModalEditShoppingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports